import { useState } from 'react';
import { tokens, Button } from '@/design';

export interface ProfileComparePanelProps {
  readonly activeProfileLabel: string;
  readonly onPickSecondProfile: () => void;
}

export function ProfileComparePanel({
  activeProfileLabel,
  onPickSecondProfile,
}: ProfileComparePanelProps) {
  const [compareActive, setCompareActive] = useState(false);

  return (
    <div
      data-testid="profile-compare-panel"
      role="region"
      aria-label="Compare profiles"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.space[2],
        padding: tokens.space[3],
        background: tokens.color.surface[2],
        borderRadius: tokens.radius.md,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: tokens.space[2],
        }}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          compare_arrows
        </span>
        <span
          style={{
            fontSize: tokens.font.size.sm,
            fontWeight: tokens.font.weight.medium,
          }}
        >
          Compare profiles
        </span>
      </div>

      <div style={{ display: 'flex', gap: tokens.space[2], alignItems: 'center' }}>
        <span
          aria-pressed={true}
          role="button"
          tabIndex={0}
          style={{
            padding: `${tokens.space[1]}px ${tokens.space[2]}px`,
            borderRadius: tokens.radius.chip,
            background: tokens.color.accent.subtle,
            border: `${tokens.border.width.thin}px solid ${tokens.color.accent.primary}`,
            fontSize: tokens.font.size.xs,
            color: tokens.color.ink.primary,
          }}
        >
          A: {activeProfileLabel}
        </span>

        {compareActive ? (
          <span
            aria-pressed={true}
            role="button"
            tabIndex={0}
            style={{
              padding: `${tokens.space[1]}px ${tokens.space[2]}px`,
              borderRadius: tokens.radius.chip,
              background: tokens.color.accent.subtle,
              border: `${tokens.border.width.thin}px solid ${tokens.color.accent.primary}`,
              fontSize: tokens.font.size.xs,
              color: tokens.color.ink.primary,
            }}
          >
            B: (selected)
          </span>
        ) : (
          <Button
            variant="secondary"
            onClick={() => {
              setCompareActive(true);
              onPickSecondProfile();
            }}
            style={{ fontSize: tokens.font.size.xs, padding: `${tokens.space[1]}px ${tokens.space[2]}px` }}
            data-testid="profile-pick-second"
          >
            Pick second profile
          </Button>
        )}
      </div>
    </div>
  );
}
